import { SelectableLegalUnitsItem } from "../processingActivity/ProcessingActivity.types";

import { useDotLegalQuery, useDotLegalQueryWithKey } from "@common/hooks/dotLegalReactQuery";
import { LegalEntityWithAddressViewModel } from "./LegalEntity.types.ts";

export function useSelectableLegalEntityQuery(isEnabled: boolean = true) {
    return useDotLegalQueryWithKey<Array<SelectableLegalUnitsItem>>("legalEntities", "/LegalEntity/selectableentities/", {
        notifyOnChangePropsExclusions: ["isStale"],
        staleTime: 15000,
        enabled: isEnabled,
    });
}

export function useSelectableLegalEntitiesWithAddress(isEnabled: boolean = true) {
    return useDotLegalQuery<Array<LegalEntityWithAddressViewModel>>("/LegalEntity/with-address/", {
        notifyOnChangePropsExclusions: ["isStale"],
        staleTime: 15000,
        enabled: isEnabled,
    });
}

export function useSelectableLegalEntitiesByOwnership(isGroupEntity: boolean) {
    return useDotLegalQueryWithKey<Array<SelectableLegalUnitsItem>>(
        "selectableLegalEntities" + isGroupEntity,
        "/LegalEntity/selectableLegalEntities/" + isGroupEntity,
        {
            notifyOnChangePropsExclusions: ["isStale"],
            staleTime: 15000,
        }
    );
}
